import { defineStore } from "pinia";
import apiClient from "@/plugins/axios";

export const useViewCounter = defineStore("viewCounter", {
  state: () => ({
    totals: {},
  }),

  actions: {
    async track(path) {
      if (!path) return;
      try {
        const { data } = await apiClient.post("/analytics/track-view", {
          path,
        });
        if (data && typeof data.total === "number") {
          this.totals[path] = data.total;
          return data.total;
        }
      } catch (e) {
        console.error(e);
      }
      return this.totals[path] ?? 0;
    },

    async get(path) {
      if (!path) return 0;
      if (this.totals[path] != null) return this.totals[path];
      try {
        const { data } = await apiClient.get("/analytics/views", {
          params: { path },
        });
        const total = typeof data?.total === "number" ? data.total : 0;
        this.totals[path] = total;
        return total;
      } catch (e) {
        return 0;
      }
    },
  },
});
